import { useViewStore } from '../../stores/viewStore'

export default function ModeToggle() {
  const liveMode = useViewStore((s) => s.liveMode)
  const routesMode = useViewStore((s) => s.routesMode)
  const toggleLiveMode = useViewStore((s) => s.toggleLiveMode)
  const toggleRoutesMode = useViewStore((s) => s.toggleRoutesMode)

  return (
    <div className="mode-toggle">
      <div className="panel-section__title">Modes</div>
      <label className="mode-toggle__item">
        <input
          type="checkbox"
          checked={liveMode}
          onChange={toggleLiveMode}
        />
        <span>Temps reel</span>
        <span className={`mode-toggle__indicator${liveMode ? ' mode-toggle__indicator--on' : ''}`} />
      </label>
      <label className="mode-toggle__item">
        <input
          type="checkbox"
          checked={routesMode}
          onChange={toggleRoutesMode}
        />
        <span>Routes optimales</span>
      </label>
    </div>
  )
}
